// PB Banner Slider is handled by src/js/blocks/pb-banner-slider.js (loaded conditionally per block)
const initPbBannerSlider = () => {};

export default initPbBannerSlider;
